import { getDownloadSelectors, getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const awmFundsDataSelector = getSelectors({
  getRootPath: selectorsConfig.awmFundsDataSelector.getRootPath,
})

export const awmFundsDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.awmFundsDownloadSelector.getRootPath,
})

export const productOperationDetailSelector = getSelectors({
  getRootPath: selectorsConfig.productOperationDetailSelector.getRootPath,
})
